import { Reveal, SectionTitle } from "@/components/site/Reveal";
import { TOPPINGS, COULIS } from "@/data/content";
import { Check } from "lucide-react";
import { motion } from "framer-motion";

const Card = ({ item, testid }) => (
  <motion.div whileHover={{ y: -6 }} data-testid={testid} className="group rounded-3xl bg-white border border-beige shadow-soft hover:shadow-hover overflow-hidden transition-all">
    <div className="aspect-square overflow-hidden bg-cream">
      <img src={item.img} alt={item.nom} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" loading="lazy" />
    </div>
    <p className="text-center font-heading text-lg font-semibold text-chocolate py-3">{item.nom}</p>
  </motion.div>
);

export const ToppingsCoulis = () => (
  <section id="toppings" className="py-20 sm:py-28 px-5 sm:px-8 bg-pastelbg">
    <div className="max-w-7xl mx-auto">
      <Reveal>
        <SectionTitle
          overline="Toppings & Coulis"
          title="Composez la glace parfaite"
          subtitle="Un large choix de gourmandises à ajouter sur votre glace à l'italienne."
        />
      </Reveal>

      <Reveal>
        <div className="mb-12 flex items-center justify-center gap-2 rounded-full bg-white border border-beige px-6 py-3 w-fit mx-auto shadow-soft">
          <Check size={18} className="text-strawberry" />
          <p className="text-sm font-semibold text-chocolate">Toppings & coulis <span className="text-strawberry">inclus</span> dans toutes nos prestations</p>
        </div>
      </Reveal>

      <Reveal delay={0.05}>
        <h3 className="font-heading text-2xl sm:text-3xl font-semibold text-chocolate mb-6">Nos toppings</h3>
      </Reveal>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-5 mb-16">
        {TOPPINGS.map((t, i) => (
          <Reveal key={t.nom} delay={(i % 5) * 0.06}>
            <Card item={t} testid={`topping-${i}`} />
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.05}>
        <h3 className="font-heading text-2xl sm:text-3xl font-semibold text-chocolate mb-6">Nos coulis</h3>
      </Reveal>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
        {COULIS.map((c, i) => (
          <Reveal key={c.nom} delay={i * 0.08}>
            <Card item={c} testid={`coulis-${i}`} />
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
